module.exports = __webpack_public_path__ + "static/media/missionControl.90ee6dfb.png";